// Vencimiento de una lectura asignada. Misma regla que el API (lib/dates.businessDayStart
// y la pestaña "Vencidas"): la fecha límite es un DÍA guardado a medianoche UTC y vence
// cuando ese día terminó en Costa Rica; el mismo día todavía no está vencida.
const BUSINESS_TZ = 'America/Costa_Rica';

function businessDay(now: Date): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: BUSINESS_TZ }).format(now);
}

export function isReadingOverdue(
  dueDate: string | null,
  pending: boolean,
  now: Date = new Date(),
): boolean {
  if (!pending || !dueDate) return false;
  return dueDate.slice(0, 10) < businessDay(now);
}
